export const reRegionConstants = {
	GetList: {
		REQUEST : 'GET_LIST_REGION_REQUEST',
		SUCCESS : 'GET_LIST_REGION_SUCCESS',
		FAILURE : 'GET_LIST_REGION_FAILURE'
	},
	GetListForRoles: {
		REQUEST : 'GET_LIST_REGION_FOR_ROLES_REQUEST',
		SUCCESS : 'GET_LIST_REGION_FOR_ROLES_SUCCESS',
		FAILURE : 'GET_LIST_REGION_FOR_ROLES_FAILURE'
	},
	CLEAR: 'CLEAR_REGION'
}